module.exports = __webpack_public_path__ + "static/media/rco-framework.721e2ce0.svg";